module.exports = __webpack_public_path__ + "img/footer-link-03.d4472915.png";